import type { IconSpec, LaunchItem } from '@hibro/shared';

/**
 * Glyph painted on a default-rendered activityBar item (见 03 / 21).
 *
 * When the item is selected and `iconActive` is declared, that spec wins;
 * otherwise the idle `icon` is used (today's behaviour: same glyph + accent
 * chrome). `custom` items never reach this — they mount a view. App-link /
 * `openUrl` items keep `item.icon` on their own branch and do not call this.
 */
export function resolveRailIconSpec(
  item: Pick<LaunchItem, 'icon' | 'iconActive'>,
  isActive: boolean,
): IconSpec | undefined {
  return isActive && item.iconActive !== undefined
    ? item.iconActive
    : item.icon;
}
